import * as Sentry from "@sentry/react";
import { env } from "~/env";

if (env.VITE_SENTRY_DSN) {
    Sentry.init({
        dsn: env.VITE_SENTRY_DSN,
        environment: env.VITE_SENTRY_ENV,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 0.1,
        // `replaysOnErrorSampleRate` здесь не задаётся намеренно: без
        // `replayIntegration` опция ничего не делает, а вместе с ней — молча включила бы
        // запись пользовательских сессий на 100%. Нужны реплеи — включать их осознанно,
        // вместе с интеграцией и с решением по доле записи.
    });
}
